import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';

type ToastOptions = Partial<SweetAlertOptions>;

const BASE_TOAST_CONFIG: SweetAlertOptions = {
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
};

const createToast = ({ icon }: { icon: SweetAlertIcon }) =>
  (title: string, options: ToastOptions = {}): void => {
    Swal.fire({
      ...BASE_TOAST_CONFIG,
      title,
      icon,
      ...options,
    });
  };

const toast = {
  success: createToast({ icon: 'success' }),
  error: createToast({ icon: 'error' }),
  warning: createToast({ icon: 'warning' }),
  info: createToast({ icon: 'info' }),
};

export default toast;